import React from 'react';
import PropTypes from 'prop-types';
import { Button, Notice } from '../uniform';
import './consent-banner.scss';

const ConsentBanner = ({ title, body, actionLabel, onActionClick, actionLoading, onDismiss }) => (
  <div className="consent-banner">
    <div className="consent-banner__inner">
      <Notice
        type="warning"
        style="standard"
        qaId="consent-banner"
        title={title}
        onDismiss={onDismiss}
        message={
          <div>
            <div className="consent-banner__body">{body}</div>
            <div className="consent-banner__action">
              <Button
                text={actionLabel}
                type="subtle"
                size="small"
                status={actionLoading ? 'spinning' : null}
                disabled={actionLoading}
                onClick={onActionClick}
                qaId="consent-banner-action"
              />
            </div>
          </div>
        }
      />
    </div>
  </div>
);

ConsentBanner.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
  actionLoading: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
};

ConsentBanner.defaultProps = {
  actionLoading: false,
};

export default ConsentBanner;
